import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Zap, Lock } from "lucide-react";
import { Seo } from "@/components/Seo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem("alight_admin_token", res.data.access_token);
      toast.success("Access granted");
      navigate("/admin");
    } catch {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 carbon-tex">
      <Seo title="Admin Login — Alight Racing" description="Alight Racing admin console." noindex />
      <div className="speed-lines" />
      <form onSubmit={submit} className="w-full max-w-md tele-card p-8 relative z-10" data-testid="admin-login-form">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 relative">
            <div className="absolute inset-0 bg-[#e77300] rotate-45" />
            <div className="absolute inset-1 bg-[#020815] rotate-45 flex items-center justify-center"><Zap className="w-4 h-4 text-[#e77300] -rotate-45" /></div>
          </div>
          <div>
            <div className="eyebrow">Alight Racing</div>
            <div className="font-display text-2xl uppercase">Admin Console</div>
          </div>
        </div>
        <div className="space-y-4">
          <div>
            <label className="eyebrow block mb-2">Email</label>
            <input type="email" className="ar-input" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" required />
          </div>
          <div>
            <label className="eyebrow block mb-2">Password</label>
            <input type="password" className="ar-input" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" required />
          </div>
          <button type="submit" disabled={loading} className="btn-racing primary w-full" data-testid="admin-login-submit">
            <span>{loading ? "Authenticating…" : "Access Console"} <Lock className="w-4 h-4" /></span>
          </button>
        </div>
        <div className="mt-6 text-[10px] font-mono-alt tracking-widest text-[#8ba3cc] uppercase text-center">Restricted Access · Internal Only</div>
      </form>
    </div>
  );
}
